// import React, { useEffect, useState } from "react";
// import img1 from "./layers/img1";
// import img2 from "./layers/img2";
// import img3 from "./layers/img3";
// import img4 from "./layers/img4";

// export default function BoxSVG(props) {
//   const [filter1, setFilter1] = useState(null);
//   const [filter2, setFilter2] = useState(null);

//   useEffect(() => {
//     const rgb1 = hexToRgb(props.innerColor);
//     setFilter1(
//       `${rgb1.r / 255} 0 0 0 0  0 ${rgb1.g / 255} 0 0 0  0 0 ${
//         rgb1.b / 255
//       } 0 0  0 0 0 1 0`
//     );
//     // Helper function to convert HEX color to RGB
//     function hexToRgb(hex) {
//       if (hex.length === 4) {
//         hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
//       }

//       const bigint = parseInt(hex.slice(1), 16);
//       const r = (bigint >> 16) & 255;
//       const g = (bigint >> 8) & 255;
//       const b = bigint & 255;
//       return { r, g, b };
//     }
//   }, [props.innerColor]);

//   useEffect(() => {
//     const rgb2 = hexToRgb(props.boxColor);
//     setFilter2(
//       `${rgb2.r / 255} 0 0 0 0  0 ${rgb2.g / 255} 0 0 0  0 0 ${
//         rgb2.b / 255
//       } 0 0  0 0 0 1 0`
//     );
//     // Helper function to convert HEX color to RGB
//     function hexToRgb(hex) {
//       if (hex.length === 4) {
//         hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
//       }

//       const bigint = parseInt(hex.slice(1), 16);
//       const r = (bigint >> 16) & 255;
//       const g = (bigint >> 8) & 255;
//       const b = bigint & 255;
//       return { r, g, b };
//     }
//   }, [props.boxColor]);

//   return (
//     <svg width="100%" height="100%" className="svgProduct hover-magnify">
//       <defs>
//         <image
//           width="48.1%"
//           id="boximg1"
//           href={"data:image/png;base64," + img1}
//         />
//         <image
//           width="10%"
//           id="boximg2"
//           href={"data:image/png;base64," + img2}
//         />
//         <image
//           width="60%"
//           id="boximg3"
//           href={"data:image/png;base64," + img3}
//         />
//         <image
//           width="7.3%"
//           id="boximg4"
//           style={{ opacity: "0.5" }}
//           href={"data:image/png;base64," + img4}
//         />
//       </defs>
//       <use
//         id="BOX INTERIOR"
//         style={{ filter: "url(#colorizeInner)" }}
//         href="#boximg1"
//         x="23.1%"
//         y="15.4%"
//       />
//       <use id="BOX RING" href="#boximg2" x="42%" y="50%" />
//       <use
//         id="BOX"
//         style={{ filter: "url(#colorizeBox)" }}
//         href="#boximg3"
//         x="20%"
//         y="10%"
//       />
//       <use id="BOX CORNER SHADOW" href="#boximg4" x="45.8%" y="74%" />
//       <image
//         className="boxLogo"
//         xlinkHref={props.logo}
//         width={
//             props.logoSize === "medium"
//               ? "13%"
//               : props.logoSize === "small"
//               ? "12%"
//               : "14%"
//           }
//         x={
//           props.logoSize === "medium"
//             ? (props.pdf ? "66.5" : "66.5") + "%"
//             : props.logoSize === "small"
//             ? (props.pdf ? "67" : "66") + "%"
//             : (props.pdf ? "65.8" : "65") + "%"
//         }
//         y={
//           props.logoSize === "medium"
//             ? (props.pdf ? "6" : "4") + "%"
//             : props.logoSize === "small"
//             ? (props.pdf ? "6" : "5") + "%"
//             : (props.pdf ? "6" : "5") + "%"
//         }
//       />
//       <filter id="colorizeBox">
//         <feColorMatrix type="matrix" values={filter2} />
//       </filter>
//       <filter id="colorizeInner">
//         <feColorMatrix type="matrix" values={filter1} />
//       </filter>
//     </svg>
//   );
// }



import React, { useEffect, useState } from "react";
import img1 from "./layers/img1";
import img2 from "./layers/img2";
import img3 from "./layers/img3";
import img4 from "./layers/img4";

export default function BoxSVG(props) {
  const [filter1, setFilter1] = useState('');
  const [filter2, setFilter2] = useState('');
  const [contrast, setContrast] = useState(0.7); // Default contrast value

  useEffect(() => {
    const rgb1 = hexToRgb(props.innerColor);
    setFilter1(
      `${rgb1.r / 255} 0 0 0 0  0 ${rgb1.g / 255} 0 0 0  0 0 ${
        rgb1.b / 255
      } 0 0  0 0 0 1 0`
    );
  }, [props.innerColor]);

  useEffect(() => {
    const rgb2 = hexToRgb(props.boxColor);
    setFilter2(
      `${rgb2.r / 255} 0 0 0 0  0 ${rgb2.g / 255} 0 0 0  0 0 ${
        rgb2.b / 255
      } 0 0  0 0 0 1 0`
    );
  }, [props.boxColor]);

  useEffect(() => {
    // Update contrast based on props
    if (props.contrast) {
      setContrast(props.contrast);
    }
  }, [props.contrast]);

  // Helper function to convert HEX color to RGB
  function hexToRgb(hex) {
    if (hex.length === 4) {
      hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }

    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  }

  return (
    <svg width="100%" height="100%" className="svgProduct hover-magnify">
      <defs>
        <image width="48.1%" id="boximg1" href={"data:image/png;base64," + img1} />
        <image width="10%" id="boximg2" href={"data:image/png;base64," + img2} />
        <image width="60%" id="boximg3" href={"data:image/png;base64," + img3} />
        <image width="7.3%" id="boximg4" style={{ opacity: "0.5" }} href={"data:image/png;base64," + img4} />
      </defs>
      <filter id="colorizeBox">
        <feColorMatrix type="matrix" values={filter2} />
        <feComponentTransfer>
          <feFuncR type="linear" slope={contrast} />
          <feFuncG type="linear" slope={contrast} />
          <feFuncB type="linear" slope={contrast} />
        </feComponentTransfer>
      </filter>
      <filter id="colorizeInner">
        <feColorMatrix type="matrix" values={filter1} />
      </filter>
      <use id="BOX INTERIOR" style={{ filter: "url(#colorizeInner)" }} href="#boximg1" x="23.1%" y="15.4%" />
      <use id="BOX RING" href="#boximg2" x="42%" y="50%" />
      <use id="BOX" style={{ filter: "url(#colorizeBox)" }} href="#boximg3" x="20%" y="10%" />
      <use id="BOX CORNER SHADOW" href="#boximg4" x="45.8%" y="74%" />
      <image className="boxLogo" xlinkHref={props.logo} width={
        props.logoSize === "medium"
          ? "10%"
          : props.logoSize === "small"
          ? "6%"
          : "14%"
      }
      x={
        props.logoSize === "medium"
          ? "66.5%"
          : props.logoSize === "small"
          ? "68%"
          : "65.8%"
      }
      y={
        props.logoSize === "medium"
          ? "6%"
          : props.logoSize === "small"
          ? "9%"
          : "5%"
      }
      />
    </svg>
  );
}